import { Spacing } from '@persona-id/design-tokens';
import { SubscribeIcon } from '@persona-id/design-tokens/icons';
import styled, { css } from 'styled-components';

import { FlagIcon } from 'dashboard/components-lib/FlagIcon/FlagIcon';
import { ExpandableContent } from 'dashboard/forms/FormReportTemplate/WatchlistListsSelect/ExpandableContent';
import { WatchlistListOption } from 'dashboard/forms/FormReportTemplate/WatchlistListsSelect/WatchlistListsSelect';
import { Paragraph } from 'design-system/components/Text';
import { BASE } from 'design-system/variables/spacing';

interface WatchlistSubscriptionDisplayProps {
  option: WatchlistListOption;
  disabled?: boolean;
  listOptions: WatchlistListOption[];
}

export const WatchlistSubscriptionDisplay = ({
  option,
  disabled,
  listOptions = [],
}: WatchlistSubscriptionDisplayProps) => {
  return (
    <WatchlistOptionDisplayContainer>
      {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
      <StyledFlagIcon flagCode={option.flagCode} border={true} />
      <WatchlistSubscriptionContainer>
        <WatchlistSubscriptionName>
          <SubscribeIcon />
          <span>{option.name}</span>
        </WatchlistSubscriptionName>
        <ExpandableContent
          id={`${option.value}`}
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          title={`${option.lists.length} list${option.lists.length > 1 ? 's' : ''}`}
          disabled={disabled}
        >
          <ul>
            {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
            {option.lists.map((list) => (
              <StyledLi key={list}>
                <Paragraph size='sm' color='secondary'>{`${
                  listOptions.find((current) => current.value === list)?.name
                }`}</Paragraph>
              </StyledLi>
            ))}
          </ul>
        </ExpandableContent>
      </WatchlistSubscriptionContainer>
    </WatchlistOptionDisplayContainer>
  );
};

interface WatchlistSourceListDisplayProps {
  option: WatchlistListOption;
  subscriptions: string[];
}

export const WatchlistSourceListDisplay = ({
  option,
  subscriptions = [],
}: WatchlistSourceListDisplayProps) => {
  return (
    <WatchlistOptionDisplayContainer $centered={true}>
      {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
      <FlagIcon flagCode={option.flagCode} border={true} />
      <div>
        <span>{option.name}</span>
        {subscriptions.length > 0 && (
          <WatchlistSubscriptionName $small={true}>
            <SubscribeIcon />
            <Paragraph size='sm' color='secondary'>
              Subscribed via {subscriptions.join(', ')}
            </Paragraph>
          </WatchlistSubscriptionName>
        )}
      </div>
    </WatchlistOptionDisplayContainer>
  );
};

export const WatchlistSubscriptionName = styled.div<{
  $small?: boolean;
}>`
  display: grid;
  grid-template-columns: ${({ $small }) => ($small ? `${Spacing[3]}` : `${Spacing[4]}`)} 1fr;
  grid-gap: ${Spacing[1]};
  align-items: center;

  ${({ $small }) =>
    $small &&
    css`
      & > svg {
        color: ${({ theme }) => theme.color.text.secondary};
        width: ${Spacing[3]};
      }
    `}
`;

const CONTAINER_MIN_HEIGHT = 62;
const FLAG_HEIGHT = 16;

export const WatchlistSubscriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${BASE * 1.25}px 0;
`;

const WatchlistOptionDisplayContainer = styled.div<{ $centered?: boolean }>`
  display: grid;
  grid-template-columns: ${Spacing[5]} 1fr;
  grid-gap: ${Spacing[4]};
  min-height: ${CONTAINER_MIN_HEIGHT}px;

  ${({ $centered }) =>
    $centered &&
    css`
      align-items: center;
    `}
`;

const StyledFlagIcon = styled(FlagIcon)`
  margin-top: ${CONTAINER_MIN_HEIGHT / 2 - FLAG_HEIGHT / 2}px;
`;

const StyledLi = styled.li`
  list-style-type: none;
`;
